export default __webpack_public_path__ + "static/media/8.1e0f4fb9.png";